import { getFileName } from "@helpers/getFileName"
import { useQuery } from "@tanstack/react-query"
import { requestApi2 } from "@utils/http"
import { PlantsPerCompany } from "@utils/listPlantsPerCompany"
import { OpModeGetLiveArgs, OpModeGetLiveResponse, endpoints } from "api"

type GetLiveOpModeArgs = {
	postData: OpModeGetLiveArgs
	plantsPerCompany: PlantsPerCompany
	filter?: { [clientName: string]: string[] }
	queryKeyTimestamp?: string
	refetchInterval?: number | false
}

export default function useGetLiveOpModeQuery(args: GetLiveOpModeArgs) {
	const queryKey = [
		`source=${getFileName()}`,
		`queryId=GetLiveOpMode`,
		`endpoints=[${endpoints.opModeGetLive2.getName()}]`,
	]
	const listOfCompanies = Object.keys(args.plantsPerCompany)
	if (listOfCompanies.length > 0) {
		const company0 = listOfCompanies[0]
		if (company0 !== undefined) {
			queryKey.push(listOfCompanies.length > 1 ? "company=Dipai" : `company=${company0}`)
			queryKey.push(`plants=${args.postData.plantIds}`)
		}
	}

	if (args.filter !== undefined) {
		const companyNameFilter = Object.keys(args.filter)[0]
		if (companyNameFilter !== undefined) {
			queryKey.push(`companyFilter=${companyNameFilter}`)
			const filterForCompany = args.filter[companyNameFilter]?.[0]
			if (filterForCompany !== undefined) {
				queryKey.push(`filter=${filterForCompany}`)
			}
		}
	}
	if (args.queryKeyTimestamp !== undefined) {
		queryKey.push(`queryTimestamp=${args.queryKeyTimestamp}`)
	}

	const response = useQuery({
		queryKey,
		queryFn: async (): Promise<OpModeGetLiveResponse | null> => {
			const data = await requestApi2(endpoints.opModeGetLive2, {
				plantIds: Array.from(new Set(args.postData.plantIds)),
			})
			return data
		},
		enabled: args.postData.plantIds.length > 0,
		staleTime: 60000,
		refetchInterval: args.refetchInterval ?? 60000,
	})
	return response
}
